import { SelectListItem } from './select-property'

export const Options_Enabled: SelectListItem[] = [
    // { value: 2, text: "All the below" },
    { value: 1, text: "Y" },
    { value: 0, text: "N" }
];